import React from 'react';
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
import IconButton from '@mui/material/IconButton';
import type { IconButtonProps } from '@mui/material/IconButton';
import FaIconUvilo from './FaIconUvilo';
import { styled, type SxProps, type Theme } from '@mui/material/styles';
import clsx from 'clsx';
import 'react18-json-view/src/style.css';
import 'react18-json-view/src/dark.css';

const BoxStyled = styled(Box)(() => ({
  '&.MuiBox-root': {
    width: '100% !important',
    //flexBasis: '100% !important',
    textAlign: 'center',
  },
}));

interface ToggleButtonProps extends IconButtonProps {
  open: boolean;
}

const ToggleButton = styled((props: ToggleButtonProps) => {
  const { ...other } = props;
  return <IconButton {...other} />;
})(({ theme }) => ({
  marginLeft: 'auto',
  transition: theme.transitions.create('transform', {
    duration: theme.transitions.duration.shortest,
  }),
  variants: [
    {
      props: ({ open }) => !open,
      style: {
        transform: 'rotate(0deg)',
      },
    },
    {
      props: ({ open }) => !!open,
      style: {
        transform: 'rotate(180deg)',
      },
    },
  ],
}));

interface AdminCollapsedBoxProps {
  rootClass?: string;
  className?: string;
  children?: React.ReactNode;
  open: boolean;
  setOpen: (open: boolean) => void;
  sx?: SxProps<Theme>;
}

const AdminCollapsedBox = ({
  rootClass,
  className,
  children,
  open,
  setOpen,
  sx,
}: AdminCollapsedBoxProps) => {
  const handleOpenClick = () => {
    setOpen(!open);
  };

  return (
    <BoxStyled className={clsx('collapsed-box', rootClass, className)} sx={sx}>
      <ToggleButton
        open={open}
        onClick={handleOpenClick}
        aria-expanded={open}
        aria-label="show more"
        sx={(theme) => ({ backgroundColor: theme.palette.background.admin })}
      >
        <FaIconUvilo icon="chevron-down" sx={{ opacity: 0.6 }} />
      </ToggleButton>
      <Collapse in={open} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </BoxStyled>
  );
};

AdminCollapsedBox.displayName = 'AdminCollapsedBox';

export default AdminCollapsedBox;
